import React, { useMemo } from 'react';
import NotFound from '@/assets/icon/404.png';
import LiveEnd from '@/assets/icon/live-end.png';
import './index.less';

interface IProps {
    type: 'liveEnd' | 'notFound';
    content?: string;
}

const ErrorPage = ({type, content}: IProps) => {
    const { imgWidth, imgHeight, image, defaultContent } = useMemo(() => {
        return {
            liveEnd: {
                imgWidth: 200,
                imgHeight: 118,
                image: LiveEnd,
                defaultContent: '直播已结束'
            },
            notFound: {
                imgWidth: 250,
                imgHeight: 100,
                image: NotFound,
                defaultContent: '您找的页面不存在了...'
            },
        }[type]
    }, [])

    return (
        <div className="not-found-wrapper">
            <img src={image} style={{width: `${imgWidth}px`, height: `${imgHeight}px`}}/>
            <div className="not-found-content">{content || defaultContent}</div>
        </div>
    );
};

export default ErrorPage;
